import {
    SET_GDC, SET_SUBJECT, SET_TOPIC, SET_CONDITION, SET_AUTHORIZE, SET_USER, SET_AMOUNT, SET_TYPE, SET_DOA, SET_SEARCH, SET_ACTION, SET_BOOK, SET_SEARCH_NAME, SET_ORG, SET_BOOK_DETAIL,
    SET_QUERY, SET_SELECTED_TOPIC, SET_SELECTED_CONDITION, RESET_DOA
} from './types';

export const setGdc = (gdc) => {
    return {
        type: SET_GDC,
        payload: gdc
    }
}

export const setSubject = (subjectList) => {
    return {
        type: SET_SUBJECT,
        payload: subjectList
    }
}

export const setTopic = (topicList) => {
    return {
        type: SET_TOPIC,
        payload: topicList
    }
}

export const setCondition = (conditionList) => {
    return {
        type: SET_CONDITION,
        payload: conditionList
    }
}

export const setAuthorize = (authorize) => {
    return {
        type: SET_AUTHORIZE,
        payload: authorize
    }
}

export const setUser = (user) => {
    return {
        type: SET_USER,
        payload: user
    }
}

export const setAmount = (amount) => {
    return {
        type: SET_AMOUNT,
        payload: amount
    }
}

export const setType = (type) => {
    return {
        type: SET_TYPE,
        payload: type
    }
}

export const setDoa = (doa) => {
    return {
        type: SET_DOA,
        payload: doa
    }
}

export const setSearch = (search) => {
    return {
        type: SET_SEARCH,
        payload: search
    }
}

export const setAction = (action) => {
    return {
        type: SET_ACTION,
        payload: action
    }
}

export const setBook = (bookCode) => {
    return {
        type: SET_BOOK,
        payload: bookCode
    }
}

export const setSearchName = (name) => {
    return {
        type: SET_SEARCH_NAME,
        payload: name
    }
}

export const setOrg = (orgList) => {
    return {
        type: SET_ORG,
        payload: orgList
    }
}

export const setBookDetail = (bookDetail) => {
    return {
        type: SET_BOOK_DETAIL,
        payload: bookDetail
    }
}

export const setQuery = (query) => {
    return {
        type: SET_QUERY,
        payload: query
    }
}

export const setSelectedTopic = (topic) => {
    return {
        type: SET_SELECTED_TOPIC,
        payload: topic
    }
}

export const setSelectedCondition = (condition) => {
    return {
        type: SET_SELECTED_CONDITION,
        payload: condition
    }
}

export const resetDoa = () => {
    return {
        type: RESET_DOA
    }
}